import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useAgencyInfo } from "../../../context/agency";
import ModuleConnect from "../components/ModuleConnect";

const wrapperStyles = {
  position: "relative",
  width: "100%",
  height: "100vh",
};

const iframeStyles = {
  width: "100%",
  height: "100%",
  border: "none",
  display: "block",
};

const LocationCreator = () => {
  const { companyId } = useParams();
  const [agency] = useAgencyInfo();
  const [iframeLoaded, setIframeLoaded] = useState(false);

  if (!agency?.modulesAuth) {
    return (
      <ModuleConnect
        icon="bi bi-geo-alt"
        title="Connect to Use Location Creator"
        description="To start creating sub-account locations from templates, connect your GoHighLevel agency account so we can provision new locations on your behalf."
      />
    );
  }

  return (
    <div style={wrapperStyles}>
      <style>{`
        .lc-loader-overlay {
          position: absolute;
          inset: 0;
          background: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 14px;
          z-index: 2;
          transition: opacity .3s ease;
        }
        .lc-loader-overlay.hidden {
          opacity: 0;
          pointer-events: none;
        }
        .lc-loader-icon {
          width: 56px;
          height: 56px;
          border-radius: 14px;
          background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
          color: #2563eb;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          box-shadow: inset 0 0 0 1px rgba(29,78,216,.12);
        }
        .lc-spinner {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: 3px solid #e2e8f0;
          border-top-color: #2563eb;
          animation: lc-spin .8s linear infinite;
        }
        @keyframes lc-spin {
          to { transform: rotate(360deg); }
        }
        .lc-loader-title {
          font-size: 14px;
          font-weight: 600;
          color: #0f172a;
        }
        .lc-loader-hint {
          font-size: 12.5px;
          color: #64748b;
        }
      `}</style>

      <div className={`lc-loader-overlay ${iframeLoaded ? "hidden" : ""}`}>
        <div className="lc-loader-icon">
          <Icon icon="solar:map-point-add-bold-duotone" />
        </div>
        <div className="lc-spinner" />
        <div className="text-center">
          <div className="lc-loader-title">Loading Location Creator</div>
          <div className="lc-loader-hint">This usually takes a moment…</div>
        </div>
      </div>

      <iframe
        src={`https://form.smartconnector.org/${companyId}/location_creator`}
        style={iframeStyles}
        onLoad={() => setIframeLoaded(true)}
      ></iframe>
    </div>
  );
};

export default LocationCreator;
